<div *ngIf="concept">
  <h3>{{ label }}</h3>
  <p>{{ concept.name }}: {{ concept.description }}</p>
  <img
    *ngIf="concept.imageDocument"
    [src]="concept.imageDocument.url"
    style="max-width: 100%; width: 600px"
    alt="Gewähltes Messkonzept" />
</div>
